
import filter from 'lodash/filter';

export default function filterDirtyAddresses(addresses) {
    const dirtyText = 'i suck ';
    return filter(addresses, (address) => !address.name?.includes(dirtyText) && !address.displayText?.includes(dirtyText));
}